import * as React from 'react';
import {Button, ButtonToolbar, Modal} from 'reactstrap';
import {change, Field, InjectedFormProps, reduxForm} from 'redux-form';
import renderSelectField from '../../../../theme/components/form/Select';
import validate from './validate';
import {mirana} from '@wize/mirana-proto/mirana-proto';

interface VisicoolerEstadoModalProps {
    toggle: any;
    isOpen: boolean;
    visicooler?: mirana.IUIVisicooler;
}

class VisicoolerEstadoModal extends React.PureComponent<InjectedFormProps & ReduxProps & VisicoolerEstadoModalProps> {

    private handleReset = () => {
        this.props.toggle();
    };

    public componentWillReceiveProps(props) {
        if (!this.props.isOpen) {
            this.props.dispatch(change('visicooler_estado_form', 'clienteId', props.visicooler ? props.visicooler.clienteId : ''));
            this.props.dispatch(change('visicooler_estado_form', 'modeloId', props.visicooler ? props.visicooler.modeloId : ''));
            this.props.dispatch(change('visicooler_estado_form', 'estado', props.visicooler ? props.visicooler.estadoId : ''));
            this.props.dispatch(change('visicooler_estado_form', 'fuerzaVentaId', props.visicooler ? props.visicooler.fuerzaVentaId : ''));
        }
    }

    private get estados() {
        return [
            {value: 1, label: 'ACTIVO'},
            {value: 2, label: 'FUGADO'},
            {value: 3, label: 'RECOJO PROGRAMADO'},
            {value: 4, label: 'ROBADO'},
            {value: 5, label: 'SERVICIO TECNICO'},
        ]
    }

    public render() {
        const {handleSubmit} = this.props;
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}
                   className={`modal-dialog--primary`}>
                <div className='modal__header'>
                    <span className='lnr lnr-cross modal__close-btn' onClick={this.props.toggle}/>
                    <h4 className='bold-text  modal__title'>Actualizar Estado</h4>
                </div>
                <div className='modal__body modelo-modal'>
                    <h5>Código: {this.props.visicooler ? this.props.visicooler.clienteId : null}</h5>
                    <h5>Razón Social: {this.props.visicooler ? this.props.visicooler.clienteRazonSocial : null}</h5>
                    <h5 style={{marginBottom: '12px'}}>Modelo: {this.props.visicooler ? this.props.visicooler.modelo : null}</h5>
                    <form className='material-form' onSubmit={handleSubmit}>
                        <div className='form__form-group'>
                            <label className='form__form-group-label'>Estado </label>
                            <div className='form__form-group-field'>
                                <Field
                                    name='estado'
                                    component={renderSelectField}
                                    placeholder='Seleccione'
                                    options={this.estados}
                                />
                            </div>
                        </div>
                        <ButtonToolbar className='modal__footer'>
                            <Button onClick={this.handleReset}>Cancelar</Button>{' '}
                            <Button type='submit' color='primary'>Aceptar</Button>
                        </ButtonToolbar>
                    </form>
                </div>
            </Modal>)
    }
}

export default reduxForm({
    form: 'visicooler_estado_form', // a unique identifier for this form
    destroyOnUnmount: false,
    validate,
})(VisicoolerEstadoModal);


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/clientes/visicooler-estado-modal.tsx